import { bridge } from '../../bridge';

/**
 * - 상품 랭킹 탭으로 이동
 * - 웹의 경우 홈으로 이동
 */
export const moveToRankingGoods = () => {
  bridge.openPath('/ranking/goods', {
    webPath: '/',
  });
};
